import React, { ReactNode, useState } from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SurgeonFormPage from '../surgeonProcedures/PreOpForm';
import { ProcedureEvent } from '../../../types/ProcedureEvent';
import { CheckCircleTwoTone } from '@material-ui/icons';
import { Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';

interface Form {
  id: number;
  name: string;
  isSigned: boolean;
}

interface FormsProps {
  procedureId: number;
  forms: Array<Form>;
  lastPreOpCompletedEvent: ProcedureEvent;
  additionalButtons?: { title: string; icon?: ReactNode; onClick: () => void }[];
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

const Forms = ({ procedureId, forms, lastPreOpCompletedEvent, additionalButtons }: FormsProps) => {
  const classes = useStyles();

  const [value, setValue] = useState<number>(0);

  return (
    <Box className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={3}>
          <List>
            {forms.map(({ id, name, isSigned }: Form, i: number) => (
              <ListItem button key={id} onClick={() => setValue(i)} selected={value === i}>
                <ListItemText
                  primary={name}
                  secondary={
                    isSigned ? (
                      <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                        <CheckCircleTwoTone fontSize="small" />
                        <Typography>Signed</Typography>
                      </Box>
                    ) : (
                      ''
                    )
                  }
                />
              </ListItem>
            ))}
          </List>
          {additionalButtons && additionalButtons?.length > 0 && (
            <>
              <Divider />
              <List>
                {additionalButtons?.map((child, i) => (
                  <ListItem button key={i} onClick={child.onClick}>
                    {child.icon && <ListItemIcon>{child.icon}</ListItemIcon>}
                    <ListItemText primary={child.title} />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </Grid>

        <Grid item lg={9}>
          {forms.map((form: Form, i: number) => (
            <TabPanel key={i} index={i} value={value}>
              <SurgeonFormPage
                id={form.id}
                procedureId={procedureId}
                lastPreOpCompletedEvent={lastPreOpCompletedEvent}
              />
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Forms;
